import { FormControl, FormHelperText } from '@mui/material';
import { useAtom } from 'jotai';
import get from 'lodash/get';
import type React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { connectionInputSchemaAtom } from '../SourceCreate.store';
import HierarchicalMultiSelect from './HierarchicalMultiSelect';
import type { CategoryMultiSelectFieldProps } from './HierarchicalMultiSelect.types';

// This component is used to render the category multi select field in the source create form. It uses react-hook-form for form state management and validation, and jotai for state management of the connection input schema.

const HierarchicalCategoryField: React.FC<CategoryMultiSelectFieldProps> = ({
  name = 'category'
}) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();
  const [connectionInputSchema] = useAtom(connectionInputSchemaAtom);

  return (
    <FormControl fullWidth error={!!get(errors, name)}>
      <Controller
        control={control}
        name={name}
        rules={{
          validate: (selected: string[] | null | undefined) => {
            const mandatory = connectionInputSchema?.mandatory_categories;

            if (!mandatory) {
              return true;
            }

            if (!selected || selected.length === 0) {
              return 'Select Category';
            }

            return true;
          }
        }}
        render={({ field }) => (
          <HierarchicalMultiSelect
            value={field.value || []}
            onChange={field.onChange}
          />
        )}
      />
      {get(errors, name) && (
        <FormHelperText error>
          {get(errors, name)?.message as string}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default HierarchicalCategoryField;
